import { useTranslation } from "react-i18next";
import Card from "../../../components/core/basic/Card";
import { css } from "../../../../styled-system/css";
import { Flex, HStack, VStack } from "../../../../styled-system/jsx";

export const SubscriptionCard = ({
  planName,
  planId,
  selectedSubscription,
  monthlySubscriptionPrice,
  annualSubscriptionPrice,
  monthlyChecked,
  subscriptionFeatures,
  onCardClick,
  annualSales,
  core,
}) => {
  const { t } = useTranslation(["admin"]);

  const isSelected = selectedSubscription === planId;
  const custom = planName?.includes("Custom");
  const isChromeExtensionCard = planName === "Chrome Extension";

  const priceIsSpecial = monthlySubscriptionPrice === "TBD" || monthlySubscriptionPrice === "Free";

  return (
    <Card
      variant={isSelected ? undefined : "flat"}
      className={css({
        cursor: isChromeExtensionCard ? "default" : "pointer",
        marginBottom: "small",
        transition: "all 0.2s ease",
        ...(isSelected && {
          outline: "2px solid",
          outlineColor: "fuchsia",
          outlineOffset: "-2px",
          backgroundColor: "rgba(217, 18, 102, 0.03)",
        }),
        ...(!isChromeExtensionCard && {
          _hover: {
            transform: "translateY(-2px)",
            boxShadow: "0 4px 24px rgba(0,0,0,.12)",
          },
        }),
      })}
      onClick={(e) => onCardClick(e, planId)}
    >
      <Flex gap="medium" alignItems="center">
        {/* Left: Plan info stacked vertically */}
        <VStack gap="small" alignItems="flex-start" flex={1}>
          <HStack gap="small" alignItems="center">
            {!isChromeExtensionCard && (
              <div
                className={css({
                  flexShrink: 0,
                  width: "16px",
                  height: "16px",
                  borderRadius: "full",
                  border: "2px solid",
                  borderColor: isSelected ? "fuchsia" : "grey",
                  background: isSelected ? "fuchsia" : "transparent",
                  transition: "all 0.2s ease",
                  position: "relative",
                  _after:
                    isSelected ?
                      {
                        content: "''",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "6px",
                        height: "6px",
                        borderRadius: "full",
                        background: "white",
                      }
                    : {},
                })}
              />
            )}
            <span
              className={css({
                color: "fuchsia",
                fontSize: "22px",
                fontWeight: 700,
              })}
            >
              {custom ? t(($) => $.admin["Trellis Platform"]) : planName}
            </span>
          </HStack>

          {annualSales && (
            <span
              className={css({
                fontSize: "14px",
                fontWeight: "bold",
              })}
            >
              <span className={css({ color: "text.secondary" })}>{t(($) => $.admin["Annual sales:"])}</span>{" "}
              {annualSales}
            </span>
          )}

          <div
            className={css({
              fontSize: "14px",
              fontWeight: "bold",
            })}
          >
            <span className={css({ color: "text.secondary" })}>{t(($) => $.admin["Features:"])}</span>
            <br />
            {subscriptionFeatures}
          </div>
        </VStack>

        {/* Right: Price */}
        <VStack gap="small" alignItems="center" flexShrink={0} alignSelf="center">
          {priceIsSpecial ?
            <span
              className={css({
                color: "text.heading",
                fontSize: "22px",
                fontWeight: 600,
                textAlign: "center",
              })}
            >
              {monthlySubscriptionPrice === "TBD" ?
                t(($) => $.admin["Talk to Customer Success"])
              : t(($) => $.admin["Free"])}
            </span>
          : <HStack gap="small" alignItems="baseline" flexWrap="wrap">
              {!monthlyChecked && (
                <span
                  className={css({
                    textDecoration: "line-through",
                    color: "text.secondary",
                    fontSize: "18px",
                    fontWeight: 600,
                  })}
                >
                  {t(($) => $.admin["{price}/mo"], { price: monthlySubscriptionPrice })}
                </span>
              )}
              <span
                className={css({
                  color: "text.heading",
                  fontSize: "34px",
                  fontWeight: 600,
                  letterSpacing: "-0.02em",
                })}
              >
                {monthlyChecked ? monthlySubscriptionPrice : annualSubscriptionPrice}
              </span>
              <span
                className={css({
                  color: "text.heading",
                  fontSize: "14px",
                })}
              >
                {t(($) => $.admin["/mo USD"])}
              </span>
              {core && (
                <span
                  className={css({
                    color: "text.heading",
                    fontSize: "14px",
                    fontWeight: 600,
                  })}
                >
                  {t(($) => $.admin["+ sales tier fee"])}
                </span>
              )}
            </HStack>
          }
        </VStack>
      </Flex>
    </Card>
  );
};
